import React from 'react'
import { motion } from 'framer-motion' 


const sectionVariant = {
    visible: {
      opacity: 1,
      transition: { ease: "easeOut", duration: 0.4, delay: 0.1 },
    },
    leave: {
      opacity: 0,
      transition: { ease: "easeIn", duration: 0.2 },
    },
};

const titleVariant = {
    visible: {
      y: 0,
      transition: { ease: "easeOut", duration: 0.4, delay: 0.1 },
    },
    leave: {
      y: 20,
      transition: { ease: "easeIn", duration: 0.2 },
    },
};



const Section4 = ({ isActive }) => {
  return (   
        <motion.div variants={sectionVariant}
            initial={false}
            animate={isActive ? "visible" : "leave"} className="mb-5 pe-lg-5 text1  py-lg-2 py-xxl-5">
            <motion.h5 
                variants={titleVariant}
                className='mb-3'>
                    Online/Offline Mock Test (CBT)
            </motion.h5>
            <motion.p   
                variants={titleVariant}
                className='col-lg-9'>
                    Get in top shape for examinations with access to over 40,000+ IGSCE, A-LEVELS, UTME, WAEC, BECE and Common Entrance Past questions and ready-made solutions.
            </motion.p>
        </motion.div>
  )
}

export default Section4